import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text2XL, text3XL } from '@styles/fonts'
import styled from 'styled-components'

export const PropertyInfoHeading = styled.h2`
  ${text3XL};
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};
  margin-bottom: 40px;
  text-transform: none;

  @media ${DEVICES.mobile} {
    ${text2XL};
    margin-bottom: 32px;
  }
`

export const PropertyInfo = styled.div``
